export default function filterPortalBiddingData(rawData, { portal = null, startDate = null, endDate = null }) {
  if (!Array.isArray(rawData)) return { labels: [], datasets: [], rawValues: {} }

  function isDateInRange(dateStr) {
    if (!dateStr) return false
    const date = new Date(dateStr)
    if (Number.isNaN(date.getTime())) return false
    if (startDate && date < new Date(startDate)) return false
    if (endDate && date > new Date(endDate)) return false
    return true
  }

  const filtered = rawData.filter(item => {
    if (portal && item.platform !== portal) return false
    if (!isDateInRange(item.dateProposal)) return false
    return true
  })

  const totalBiddings = filtered.length
  const wonBiddings = filtered.filter(item => item.phase === 'GANHOS').length
  const conversionRate = totalBiddings > 0 ? (wonBiddings / totalBiddings) * 100 : 0

  const totalContractValue = filtered
    .filter(item => item.phase === 'GANHOS')
    .reduce((sum, item) => sum + (item.contractCost || 0), 0)

  const averageContractValue = wonBiddings > 0 ? totalContractValue / wonBiddings : 0

  return {
    labels: [
      'Número de Licitações',
      'Taxa de Conversão (%)',
      'Valor Médio dos Contratos (R$)',
      'Valor Total dos Contratos (R$)',
    ],
    datasets: [
      {
        label: `Indicadores do Portal ${portal || 'Selecionado'}`,
        data: [
          totalBiddings,
          Number(conversionRate.toFixed(2)),
          Number(averageContractValue.toFixed(2)),
          Number(totalContractValue.toFixed(2)),
        ],
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
        ],
      },
    ],
    rawValues: {
      totalBiddings,
      conversionRate: Number(conversionRate.toFixed(2)),
      averageContractValue: Number(averageContractValue.toFixed(2)),
      totalContractValue: Number(totalContractValue.toFixed(2)),
    },
  }
}
